/* eslint no-use-before-define: 0 */ // --> OFF
<template>
  <form @submit.prevent="confirm()">
    <div>
      <div class="form-group">
        <label for="numero">La liste des Contenants à importer au format .xlsx</label>
        <input
          type="file"
          accept=".xlsx"
          class="form-control"
          id="numero"
          ref="fileInput"
          name="file"
          v-on:change="getfile($event)"
          maxlength="50"
          required
        />
      </div>
    </div>

    <div class="buttons">
      <button class="btn btn-primary">Confirmer</button>
      <div class="btn btn-default" v-on:click="$emit('close')">
        Annuler
      </div>
    </div>
  </form>
</template>
<script>
import { mapState } from 'vuex'
import _ from 'lodash'
import rowToObject from '../../../utils/csvProps'
import readXlsxFile from 'read-excel-file'

export default {
  computed: {
    ...mapState([ 'secteurs','contenants' ]),
  },
  data: function () {
    return {
      fileBinder: null,
    }
  },
  methods: {
    confirm: function () {
      this.parseCsv(this.fileBinder)
      this.$emit('close')
    },
    getfile: function (event) {
      var file = event.target.files[0]
      // l'extention du fichier doit etre xlsx
      if (/^.+\.([^.]+)$/.exec(file.name)[1] !== 'xlsx') {
        const input = this.$refs.fileInput
        input.type = 'text'
        input.type = 'file'
        window.alert('Veuillez sélectionner un fichier valide')
      }
      this.fileBinder = file
    },
    parseCsv: function (file) {
      var $this = this
      readXlsxFile(file).then((rows) => {
        console.log(rows)
        rows.shift()
        var collects = rowToObject(rows, this.secteurs.data, this.contenants.data)
        _.each(collects, function (currCol) {
          $this.$store.dispatch('createContenant', currCol)
        })
      })
    },
  },
  mounted: function () {
    this.$store.dispatch('fetchSecteursByVilleId')
    this.$store.dispatch('fetchAllContenants');
  },
}
</script>

<style lang="scss">
textarea {
  resize: none;
  height: 140px !important;
}
.map-wrapper {
  position: relative;
  width: 100%;
  height: 400px;

  .map-container {
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// CollecteFormCsv.vue?d0edc972